<script lang="ts" setup>
import type { Props } from './types'
import { deepCopy } from '@/utils/objects'

defineProps<Props>()
const emit = defineEmits(['actionable-click'])
</script>

<script lang="ts">
export default {
  name: 'AppAiChatPassiveRecommendation'
}
</script>

<template>
  <div class="chat-passive-recommendation">
    <p>
      <template
        v-for="(fragment, index) in fragments"
        :key="`fragment-${index}`">
        <span v-if="fragment.actionable.value?.results?.length">
          {{ fragment.prefix }}

          <span
            :id="`chat-passive-recommendation-${reference}`"
            class="chat-passive-recommendation__highlight text-brand-600 underline px-2 cursor-pointer"
            :data-lh-id="`chat-passive-recommendation-${reference}`"
            @click="() => emit('actionable-click', deepCopy(fragment.actionable.value))">
            {{ fragment.actionable.label }}
          </span>

          {{ fragment.suffix }}
        </span>
      </template>
    </p>
  </div>
</template>
